"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../../../../../hooks");
var _CetComponentsProvider = require("../../../../../../../providers/CetComponentsProvider");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = function useStyles() {
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    themeColors = _useContext.themeColors;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var ccTaskManagerTaskDateTimePickerStyle = (0, _react.useMemo)(function () {
    var deviceBtnProps = function deviceBtnProps() {
      var width = isMobileView ? '100%' : 'auto';
      return {
        width: width
      };
    };
    var ccTaskManagerTaskDateTimePicker = (0, _css.css)({});
    var ccTaskManagerTaskDateTimePickerFrame = (0, _css.css)({
      display: 'flex',
      border: "1px solid ".concat(themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.border),
      borderRadius: pxToRem(isMobileView ? 6 : 25),
      width: isMobileView ? 'auto' : 'fit-content',
      padding: "0 ".concat(pxToRem(24)),
      gap: pxToRem(24),
      '& > div:nth-child(1)': _objectSpread({}, deviceBtnProps()),
      '& > div:nth-child(3)': _objectSpread({}, deviceBtnProps())
    });
    var ccTaskManagerTaskDateTimePickerFrameSpacer = (0, _css.css)({
      width: '1px',
      background: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.border,
      margin: "".concat(pxToRem(1), " 0")
    });
    return {
      ccTaskManagerTaskDateTimePicker: ccTaskManagerTaskDateTimePicker,
      ccTaskManagerTaskDateTimePickerFrame: ccTaskManagerTaskDateTimePickerFrame,
      ccTaskManagerTaskDateTimePickerFrameSpacer: ccTaskManagerTaskDateTimePickerFrameSpacer
    };
  }, [isMobileView, pxToRem, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.border]);
  return {
    'cc-TaskManager__task-date-time-picker': ccTaskManagerTaskDateTimePickerStyle.ccTaskManagerTaskDateTimePicker,
    'cc-TaskManager__task-date-time-picker__frame': ccTaskManagerTaskDateTimePickerStyle.ccTaskManagerTaskDateTimePickerFrame,
    'cc-TaskManager__task-date-time-picker__frame-spacer': ccTaskManagerTaskDateTimePickerStyle.ccTaskManagerTaskDateTimePickerFrameSpacer
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;